import React from "react";

export const CATEGORY_LABELS = {
  casco: "Casco",
  imbracatura: "Imbracatura",
  cordino: "Cordino",
  cassetta_primo_soccorso: "Cassetta Primo Soccorso",
  fettuccia: "Fettuccia",
  arrotolatore: "Arrotolatore",
  moschettone: "Moschettone",
  altro: "Altro",
};

export const STATUS_LABELS = {
  scaduto: "SCADUTO",
  in_scadenza: "IN SCADENZA",
  valido: "VALIDO",
  fallito: "NON IDONEO",
  non_ispezionato: "NON ISPEZIONATO",
  non_revisionato: "DA VERIFICARE",
};

export function StatusBadge({ status }) {
  return (
    <span className={`bru-badge badge-${status}`} data-testid={`status-badge-${status}`}>
      {STATUS_LABELS[status] || (status || "").toUpperCase()}
    </span>
  );
}

export function ResultBadge({ result }) {
  return (
    <span className={`bru-badge badge-${result}`} data-testid={`result-badge-${result}`}>
      {result === "superato" ? "SUPERATO" : "FALLITO"}
    </span>
  );
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime()) || d.getFullYear() < 1900 || d.getFullYear() > 2200) return "—";
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return "—";
  }
}

export function daysUntil(iso) {
  if (!iso) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const exp = new Date(iso);
  exp.setHours(0, 0, 0, 0);
  return Math.round((exp - today) / (1000 * 60 * 60 * 24));
}
